import { useContext } from 'react'
import { CloudflareInfoContext } from './Provider'

export const useCloudflareInfo = () => useContext(CloudflareInfoContext)

export type { CloudflareInfo } from './Provider'
